import type { SxProps, Theme } from '@mui/material';

import { IllustrationWrapper } from '../IllustrationWrapper';

import { FillFormsIllustration } from './FillForms';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly title?: string;
}

export const FillForms = ({ sx, title }: Readonly<Props>) => (
  <IllustrationWrapper sx={sx}>
    <FillFormsIllustration title={title} />
  </IllustrationWrapper>
);
